import { useTranslation } from "react-i18next";
import Select from "@/components/common/form/select";
import Input from "@/components/common/form/input";
import Radio from "@/components/common/form/radio";
import Button from "@/components/common/form/button";
import { useSwrGet } from "@/utils/use-swr-get";
import { authServices } from "services/auth.services";
import Loader from "@/components/common/loader.components";
function SubmitButton({ t, passProps, ...props }) {
  return (
    <Button
      title={t("Save")}
      className="w-full h-[35px] text-white rounded-lg bg-main  text-md mt-5"
      loading={props?.formState?.isSubmitting ?? false}
    />
  );
}
function machinaryForm({ icon, passProps, ...props }) {
  const { t } = useTranslation();

  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );
  const {
    data: suppliers,
    isLoading: suppliersIsLoading,
    isError: suppliersIsError,
  } = useSwrGet(
    `/suppliers/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `suppliers/?org_id__id=${authServices.userValue.org_id}`
  );
  if (farmIsLoading || suppliersIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="flex flex-col w-9/12 ">
        <Input
          name="machinery_code"
          label={t("MachineryCode")}
          icon={() => (
            <p className="px-2 pt-4 text-sm font-bold outline-none appearance-none text-mako">
              {icon}
            </p>
          )}
          {...props}
        />
        <Select
          label={t("Select Farm")}
          name="farm_id"
          options={farmData?.map?.((farm) => ({
            label: farm.farm_name,
            value: farm.farm_id,
          }))}
          {...props}
        />

        <Select
          label={t("Select Field")}
          name="object_id"
          options={
            props.getValues().farm_id
              ? farmData
                  ?.filter?.(
                    (farm) => farm.farm_id == props.getValues().farm_id
                  )
                  ?.map?.((item) => item.fields)[0]
                  ?.map?.((item) => ({
                    label: item.field_name,
                    value: item.field_id,
                  }))
              : []
          }
          {...props}
        />

        <Select
          label={t("MachineryCategory")}
          name="machinery_category"
          options={[
            { value: "tractor", label: t("tractor") },
            { value: "plower", label: t("plower") },
            { value: "disk", label: t("disk") },
            { value: "marker", label: t("marker") },
            { value: "planter", label: t("planter") },
            { value: "spreader", label: t("spreader") },
            { value: "sprayer", label: t("sprayer") },
            { value: "opener", label: t("opener") },
            { value: "digger", label: t("digger") },
            { value: "harvester", label: t("harvester") },
            { value: "horsch_tiger", label: t("horsch tiger") },
            { value: "rotavator", label: t("Rotavator") },
          ]}
          {...props}
        />
        <Select
          label={t("Supplier")}
          name="supplier_id"
          options={suppliers?.results?.map?.((user) => ({
            label: user.supplier_name,
            value: user.id,
          }))}
          {...props}
        />

        <Input
          name="asset_ref_no"
          label={t("AssetRefNo")}
          type="number"
          {...props}
        />

        <Select
          name="machinery_ownership"
          label={t("MachineryOwnership")}
          required={true}
          options={[
            { label: t("Owned"), value: "owned" },
            { label: t("Rented"), value: "rented" },
          ]}
          {...props}
        />
      </div>

      <div className="text-lg font-semibold text-mako ">
        {t("Who_provide_these_items?")}
      </div>
      <div>
        <div className="inline-block w-1/2">
          <Radio
            label={t("Driver")}
            name="driver"
            required={true}
            options={[
              { label: t("Company"), value: "company" },
              { label: t("External"), value: "external" },
            ]}
            dir="row"
            {...props}
          />
        </div>

        <div className="inline-block w-1/2">
          <Radio
            name="oil"
            label={t("Oil")}
            required={true}
            options={[
              { label: t("Company"), value: "company" },
              { label: t("External"), value: "external" },
            ]}
            dir="row"
            {...props}
          />
        </div>

        <div className="inline-block w-1/2">
          <Radio
            name="petrol"
            label={t("Petrol")}
            required={true}
            options={[
              { label: t("Company"), value: "company" },
              { label: t("External"), value: "external" },
            ]}
            dir="row"
            {...props}
          />
        </div>
        <div className="inline-block w-1/2">
          <Radio
            name="maintenance"
            label={t("Maintenance")}
            required={true}
            options={[
              { label: t("Company"), value: "company" },
              { label: t("External"), value: "external" },
            ]}
            dir="row"
            {...props}
          />
        </div>
      </div>

      <SubmitButton t={t} passProps />
    </>
  );
}

export default machinaryForm;
